import React from "react";
import { useSelector } from "react-redux";
import SustainabilityImage from "./components/SustainabilityImage";

const Sustainability = () => {
  const dark = useSelector((state) => state.dark.data);
  return (
    <>
      <div
        className="dashboard h-100 w-100 overflow-y-auto"
        style={{
          backgroundImage: `url('./images/building${
            dark ? "" : "-Light"
          }.png')`,
        }}
      >
        <div className="container-fluid d-flex align-items-center justify-content-center py-3 h-100 ">
          <div className="row w-100 h-100 flex-column flex-lg-row p-2 overflow-hidden">
          {/* <img src="/images/sustainability-screen2.png" alt="" class="img-fluid w-100 h-100 object-fit-cover" /> */}
           
              <SustainabilityImage/>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sustainability;
